import { useState } from 'preact/hooks';
import { ClockIcon } from './Icons.jsx';

/**
 * Outside staffed hours. Names the next staffed hour from the rota rather than
 * a generic "we'll be back" — the merchant can decide whether to wait.
 * The message still posts normally; the agent picks it up on shift.
 */
export function Offline({ nextOpen, onSend, sending }) {
  const [message, setMessage] = useState('');

  const submit = (event) => {
    event.preventDefault();
    const body = message.trim();
    if (body) onSend({ body });
  };

  return (
    <form class="form" onSubmit={submit}>
      <div class="notice">
        <span style={{ color: 'var(--sc-tx3)', marginTop: '1px', flex: 'none', display: 'flex' }}>
          <ClockIcon size={15} />
        </span>
        <div>
          <div class="notice__title">We're offline right now</div>
          <div class="notice__body">
            {nextOpen
              ? `Back at ${nextOpen.time}${nextOpen.when} — ${nextOpen.away}. Leave a message and we'll reply by email.`
              : "Leave a message and we'll reply by email as soon as we're back."}
          </div>
        </div>
      </div>

      <textarea
        class="field__textarea field__textarea--tall"
        placeholder="What can we help with?"
        aria-label="Your message"
        value={message}
        onInput={(e) => setMessage(e.currentTarget.value)}
      />

      <button class="button" type="submit" disabled={sending || !message.trim()}>
        {sending ? 'Sending…' : 'Leave a message'}
      </button>
    </form>
  );
}

export default Offline;
